import script from "./AnnouncementIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementIndex.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementIndex.vue?vue&type=style&index=0&id=524bb09f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524bb09f"]])

export default __exports__